// Stub file for EnumDocs
// This file was removed but is needed for backward compatibility

export interface EnumValueDoc {
  name: string;
  value: number;
  comment: string;
}

export interface EnumDoc {
  typeName: string;
  displayName: string;
  category: string;
  comment: string;
  values: EnumValueDoc[];
}

export const enumDocumentationData: EnumDoc[] = [];
